
import { Route, Routes } from 'react-router-dom';

import { ToastContainer } from 'react-toastify';
import { initCustomAlerts } from './helpers/alertError';
import NotFoundPage from './pages/main/NotFoundPage';
import MainNav from './navigation/MainNav';
import AuthNav from './navigation/AuthNav';
import AccountNav from './navigation/AccountNav';
import ScrollToTop from './components/ui/ScrollToTop';


function App() {

  // Initialiser le remplacement des alerts
  initCustomAlerts();

  return (

    <ScrollToTop>
      <ToastContainer position="top-right" autoClose={3000} />

      <Routes>

        <Route path="/*" element={<MainNav />} />
        <Route path="/auth/*" element={<AuthNav />} />

        <Route path="/compte/*" element={<AccountNav />} />

        <Route path="*" element={<NotFoundPage />} />


      </Routes>

    </ScrollToTop>
  );
}

export default App;
